const { listOrdersForUser } = require('./internal')
const get = require('lodash/get')

exports.getFacilityDraftOrder = getFacilityDraftOrder
async function getFacilityDraftOrder (
  state,
  location,
  { programId, forceAtSupplier = false } = {}
) {
  const locationProgramId = get(location, 'programs[0].id')
  const requestedProgramId = programId || locationProgramId
  const locationId = location._id

  const { orders } = await listOrdersForUser(state, requestedProgramId, locationId,
    { withAccepted: true, withSnapshots: true, isComplete: false, forceAtSupplier }, true)

  if (orders.length === 0) {
    return null
  }

  const openOrders = orders.filter(order => order.status === 'new' && !order.closedStatus)

  if (openOrders.length > 1) {
    const orderIds = openOrders.map(order => order._id)
    console.error('More than one open facility order found:', orderIds)
    throw new Error(`More than one open facility order found: ${orderIds.join(', ')}`)
  }

  return openOrders[0] || null
}
